if (!customElements.get('update-cart-item')) {
  customElements.define(
    'update-cart-item',
    class UpdateCartItem extends HTMLElement {
      constructor() {
        super();
        this.lineItemPropertiesInput = this.querySelector('input[name="line_item_properties"][type="hidden"]');
        this.handleLineItemProperties();
      }

      handleLineItemProperties() {
        const itemValue = this.lineItemPropertiesInput.value;
        if (!itemValue) return;

        const parsedItemValue = JSON.parse(itemValue);

        this.sendPostRequestWithRetry('/cart/change.js', {
          id: parsedItemValue.id,
          properties: parsedItemValue.properties,
        });
      }

      async sendPostRequestWithRetry(url, data, maxRetries = 3, delay = 1000) {
        for (let attempt = 1; attempt <= maxRetries; attempt++) {
          try {
            const response = await fetch(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(data),
            });

            if (!response.ok) throw new Error(`Server error: ${response.status}`);

            const result = await response.json();
            return result;
          } catch (error) {
            console.error(`Attempt ${attempt} failed: `, error);

            if (attempt < maxRetries) {
              const retryDelay = delay * Math.pow(2, attempt - 1); // Exponential backoff
              await new Promise((resolve) => setTimeout(resolve, retryDelay));
            } else {
              console.error('All retry attempts failed.');
            }
          }
        }
      }
    }
  );
}
